<template>
  <div class="fdd-form-item">
    <label class="fdd-form-item_label" :class="{ 'is-required': required }" :style="`width: ${labelWidth};`">
      {{ label }}
    </label>
    <div class="fdd-form-item_content" :style="`margin-left: ${labelWidth};`">
      <slot />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'FddFormItem',

    props: {
      label: {
        type: String,
        default: ''
      },

      labelWidth: {
        type: String,
        default: '100px'
      },

      // 是否必填
      required: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style lang="less">
  .clearfix {
    &::before,
    &::after {
      display: table;
      content: '';
    }

    &::after {
      clear: both;
    }
  }

  .fdd-form-item {
    @label: 100px;
    .clearfix;
    position: relative;
    margin-bottom: 15px;

    &_label {
      float: left;
      vertical-align: middle;
      box-sizing: border-box;
      padding-left: 15px;
      padding-right: 5px;
      width: @label;
      line-height: 30px;

      &.is-required::before {
        position: absolute;
        left: 0;
        content: '*';
        color: #ff5846;
      }
    }

    &_content {
      .clearfix;
      position: relative;
      margin-left: @label;
      line-height: 30px;
    }

    // 修正其他控件样式
    .fddform-input-number .input-number {
      top: 0;
    }
  }
</style>
